@if (isBrowser) {
  <mat-icon
    svgIcon="{{svgIcon}}"
    class="{{class}}">{{icon}}</mat-icon>
}